module.exports = __webpack_public_path__ + "static/media/klasa_8.782bf820.svg";